/**
 * The tuning panel (F1) is for the game's maker, and never on the live game: it only works on the maker's
 * own copies (this computer, a phone on the same network, the staging copy), in a browser that has opened
 * the game with ?dev=1 once (?dev=0 forgets it). On grandprem.io it doesn't exist, ?dev=1 or not.
 */
const host = typeof location === 'undefined' ? '' : location.hostname;

export const DEV_HOST =
  host === 'localhost' ||
  host === '127.0.0.1' ||
  /^(10|192\.168|172\.(1[6-9]|2\d|3[01]))\./.test(host) ||
  host.includes('staging');

export const DEV = ((): boolean => {
  if (!DEV_HOST) return false;
  const params = new URLSearchParams(location.search);
  try {
    if (params.get('dev') === '1') localStorage.setItem('gp.dev', '1');
    if (params.get('dev') === '0') localStorage.removeItem('gp.dev');
    return localStorage.getItem('gp.dev') === '1';
  } catch {
    return params.get('dev') === '1';
  }
})();
